import { isLoggedIn } from '../../utils/auth'

export default (store) => {
  return ({
    path: 'rse-referral',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      const referral = require('./containers').default
      cb(null, referral)
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/CromaRseReferral/index.js